<template>
    <PackagesList/>
</template>
<script>
import PackagesList from '../../components/packages/PackagesList';

export default {
  components: {
    PackagesList,
  },
};
</script>
